import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_ALIAS = gql`
  mutation addOrUpdateAlias($input: AddOrUpdateAliasInput!) {
    addOrUpdateAlias(input: $input) {
      errors
      aliasUuid
      aliasRecord {
        id
        description
        createdAt
        updatedAt
        target {
          id
          personalAttribute {
            dob
            firstName
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                officer {
                  id
                }
              }
            }
            mailingAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
            }
            id
            lastName
            middleName
            organization
            phone
            cell
            suffix
            driversLicense
            fishWildlifeLicense
            licenseState {
              id
              name
              oriId
              position
            }
          }
        }
      }
    }
  }
`;
